import { styled } from '@zoopla-eng/zds-components/themes';
import { PageSubtitleShort } from '@zoopla-eng/zds-components/headings';

export const StyledTitle = styled(PageSubtitleShort, {
    color: '$textContrast'
});

export const StyledText = styled('p', {
    fontGroup: 'ladle',
    color: '$textContrast'
});
